export const faqs = [
  {
    q: "为什么同一个瓜，说法总是变来变去？",
    a: "因为大瓜往往由多个互相竞争的说法组成：当事人会更新回应，平台会发布公告，第三方爆料会不断补充。说法变化本身是正常的，建议以时间线为轴，把每一次更新串起来看，别被单条说法带跑。",
  },
  {
    q: "网站上的瓜单信息靠谱吗？信息来源是什么？",
    a: "我们的瓜单以当事人原话、官方公告、可交叉验证的现场记录为主要信源，并在每篇内容里给出必看线索。复盘类内容我们会标明哪些是确认信息、哪些仍是待核实传闻，尽量不把推测当结论写。",
  },
  {
    q: "我错过了前情，怎么快速补课？",
    a: "每期瓜单都带有事件时间线与开场导语，从起因到后续按顺序排好。你也可以先读「新手吃瓜指南」专栏，学会把事件拆成起因—引爆—反转—后续四段，三分钟就能跟上节奏。",
  },
  {
    q: "我可以投稿线索或提供自己整理的瓜单吗？",
    a: "当然欢迎。在「关于我们」页面的投稿表单留下事件主题、联系方式与线索说明即可。被采纳的内容我们会标注来源，并在确认信息可靠后纳入瓜单或复盘专栏。",
  },
  {
    q: "这里的内容是客观报道，还是带立场的？",
    a: "瓜单部分力求中立，把时间线与多方说法陈列清楚；复盘和观点类专栏则会明确标注为作者观点。无论哪种，我们都会给你留下自己的判断空间，而不是替你把结论定死。",
  },
  {
    q: "内容多久更新一次？",
    a: "热度高、还在发酵的大瓜通常即时跟进，常态化的瓜单与榜单每日滚动更新；吃瓜指南等长内容按选题节奏更新。你可以把页面加入收藏，或常回来看看「本期瓜单」。",
  },
];